import { useEffect, useState } from "react";
import api from "services/api";
import config from "config";
import './style.css';
import { formatDate } from "components/formatos";

function LISTAEXTRATO() {
    const [lnotas, setlNotas] = useState([]);
    const [searchTerm, setSearchTerm] = useState(""); // Estado para o termo de busca
    const [filteredNotas, setFilteredNotas] = useState([]); // Estado para a lista filtrada

    useEffect(() => {
        // Busca Participantes
        api.get(config.EXTRATO)
            .then(response => {
                setlNotas(response.data);
                setFilteredNotas(response.data); // Inicializa a lista filtrada
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        // Filtra os participantes com base no termo de busca
        setFilteredNotas(
            lnotas.filter(lista =>
                lista.nomeestabelecimento.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, lnotas]);

    return (
        <div>
            <h1 className="section-title">
                <i className="fas fa-file-invoice-dollar" style={{marginRight: '12px'}}></i>
                Meu Extrato de Lançamentos
            </h1>

            <div className="extrato-search-container mb-4">
                <div className="input-group search-box">
                    <span className="input-group-text bg-white border-end-0">
                        <i className="fas fa-search text-muted"></i>
                    </span>
                    <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="Buscar por estabelecimento..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="row">
                {filteredNotas.map((d) => {
                    return (
                        <div key={`venda${d.id_venda}`} className="col-12 col-md-6 col-lg-4 p-2">
                            <div className="extrato-card">
                                <div className="extrato-icon-container">
                                    <i className="fas fa-receipt"></i>
                                </div>
                                <div className="extrato-content">
                                    <div className="extrato-main-info">
                                        <h5 className="extrato-estab">{d.nomeestabelecimento}</h5>
                                        <span className="extrato-value">
                                            R$ {d.valor_venda.toFixed(2).replace('.', ',')}
                                        </span>
                                    </div>
                                    <div className="extrato-meta">
                                        <span className="extrato-date">
                                            <i className="far fa-calendar-alt me-1"></i>
                                            {formatDate(d.dat_venda)}
                                        </span>
                                        <span className="extrato-id">
                                            ID: #{d.id_venda}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
                {filteredNotas.length === 0 && (
                    <div className="col-12 text-center py-5">
                        <div className="opacity-50">
                            <i className="fas fa-folder-open fa-3x mb-3"></i>
                            <p>Nenhum lançamento encontrado.</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default LISTAEXTRATO;
